import { type FC } from 'react'

import {
  CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER,
  CrossSellHorizontalSlider,
  CrossSellWidgetContainer,
  CrossSellWidgetProvider,
  CrossSellWidgetTitle,
  useCrossSellConfigContext,
  useCrossSellIntersection,
  useCrossSellWidgetTitle,
  useSwrCrossSellHorizontalSlider,
} from '../../../../cross-sell'
import { gtmDataLayerPushCswProduct } from '../../../../gtm'
import { useProductPageContext } from '../../productPageContext'

import { useProductCrossSellOutOfStockWidget } from './useProductCrossSellOutOfStockWidget'

type ProductCrossSellOutOfStockSliderWidgetProps = {
  className?: string
  itemsPerPage: number
}

export const ProductCrossSellOutOfStockSliderWidget: FC<
  ProductCrossSellOutOfStockSliderWidgetProps
> = ({ className, itemsPerPage }) => {
  const { widgets } = useCrossSellConfigContext()
  const { product } = useProductPageContext()
  const useWidget = useProductCrossSellOutOfStockWidget()

  const { handleIntersection, intersected } = useCrossSellIntersection()

  const widgetId = widgets[CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER]?.id

  const { data, error } = useSwrCrossSellHorizontalSlider(
    intersected && widgetId && useWidget
      ? {
          categoryId: product.category?.code ?? '',
          categoryLabel: 'productcategory',
          productId: product.upid,
          visibleItemCount: 6,
          widgetId,
        }
      : undefined,
  )
  const widgetTitle = useCrossSellWidgetTitle({
    data,
    widgetType: CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER,
  })

  if (!widgetId || !useWidget || data?.items.length === 0 || error) {
    return null
  }

  return (
    <CrossSellWidgetContainer
      className={className}
      onIntersect={handleIntersection}
      widgetData={data}
      widgetId={widgetId}
      widgetType={CROSS_SELL_PDP_OUT_OF_STOCK_CENTER_SLIDER}
    >
      <CrossSellWidgetTitle className="mb-2.5 text-xl tablet:text-2xl">
        {widgetTitle}
      </CrossSellWidgetTitle>
      <CrossSellWidgetProvider value={{ widgetId }}>
        <CrossSellHorizontalSlider
          onGtmDataLayerPush={(cswProductId) => {
            gtmDataLayerPushCswProduct({
              cswProductId,
              productId: product.upid,
              widgetId,
              widgetTitle,
            })
          }}
          products={data?.items}
          productsPerPage={itemsPerPage}
        />
      </CrossSellWidgetProvider>
    </CrossSellWidgetContainer>
  )
}
